// extracted by mini-css-extract-plugin
export default {"title":"AiPhotoGenerationCancelGenerationModal__title--2zF-j","description":"AiPhotoGenerationCancelGenerationModal__description--1qR9N"};